import { delayRepayRoute } from './helpers';
import { DelayRepayPages } from '../../../../src/constants/AppConstants';

export default delayRepayRoute(DelayRepayPages.CLAIMS, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/delayRepay/Claims').default);
        }, 'delayrepay-claims');
    }
});
